import axios from "axios";

let url = '/ai_chat';


// 获取会话id
export async function startNew(brand='smartz'){
  let res = await axios.post(`${url}/session/startNewSession`, {brand: brand});
  let data = res.data;

  return data;
}

// 开始会话
export async function chatStart(id, text){
  let req = {
    query: text
  }
  let res = await axios.post(`${url}/session/chatInSession/${id}`, req);
  let data = res.data;

  return data;
}

// 会话结束  移除会话
export async function chatEnd(id){
  let res = await axios.delete(`${url}/session/deleteSession/${id}`);
  let data = res.data;

  return data;
}

// 获取一个会话记录
export async function getAchatRecord(id){
  let res = await axios.get(`${url}/session/get/${id}`);
  let data = res.data;

  return data;
}

// 刷新会话id
export async function refreshSession(id){
  let res = await axios.post(`${url}/session/refreshSession/${id}`);
  let data = res.data;

  return data;
}



// WEBPACK FOOTER //
// ./src/api/aiChat.js